import { render, staticRenderFns } from "./budgetPlan2.vue?vue&type=template&id=4d227e6b&scoped=true"
import script from "./budgetPlan2.vue?vue&type=script&lang=js"
export * from "./budgetPlan2.vue?vue&type=script&lang=js"
import style0 from "./budgetPlan2.vue?vue&type=style&index=0&id=4d227e6b&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d227e6b",
  null
  
)

export default component.exports